import { getStandaloneDistributorUrl } from '../../../modules/configuration/selectors';
import { DistributorThunkAction } from '../../../types';

export const redirectToStandalone =
    (): DistributorThunkAction =>
    (_dispatch, getState, { environmentService }) => {
        const standaloneUrl = getStandaloneDistributorUrl(getState());
        environmentService.invokeArgs('open', [standaloneUrl, '_blank', 'noopener']);
    };
